import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { FileUpload } from "primereact/fileupload";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";

import InputCRM from "components/RH/inputs/InputCRM";
import InputDate from "components/RH/inputs/InputDate";

const ExameMedico = ({
  dados,
  HandleChange,
  statusAptidao,
  setStatusAptidao,
  HandleExameChange,
  errors = {},
  exameFile
}) => {
  const fileUploadRef = useRef(null);

  // Restaurar arquivo quando o componente for montado
  useEffect(() => {
    if (exameFile && fileUploadRef.current) {
      fileUploadRef.current.setFiles([exameFile]);
    }
  }, [exameFile]);
  
  return (
  <div className="row g-3">
    <div className="col-md-6 col-lg-3">
      <label htmlFor="nomeMedico" className="form-label">
        Nome do Médico <span className="text-danger">*</span>
      </label>
      <InputText
        id="nomeMedico"
        name="nomeMedico"
        value={dados.nomeMedico}
        onChange={HandleChange}
        className={`form-control ${errors.nomeMedico ? 'is-invalid' : ''}`}
      />
      {errors.nomeMedico && (
        <div className="invalid-feedback">
          Nome do médico é obrigatório
        </div>
      )}
    </div>
    <div className="col-md-6 col-lg-3">
      <label htmlFor="crm" className="form-label">
        CRM <span className="text-danger">*</span>
      </label>
      <InputCRM
        id="crm"
        name="crm"
        value={dados.crm}
        onChange={HandleChange}
        className={`form-control ${errors.crm ? 'is-invalid' : ''}`}
        placeholder="123456/SP"
      />
      {errors.crm && (
        <div className="invalid-feedback">
          CRM é obrigatório
        </div>
      )}
    </div>
    <div className="col-md-6 col-lg-3">
      <label htmlFor="dataAdmissaoExam" className="form-label">
        Data do Exame <span className="text-danger">*</span>
      </label>
      <InputDate
        id="dataAdmissaoExam"
        name="dataAdmissaoExam"
        value={dados.dataAdmissaoExam}
        onChange={(dateString) => HandleChange({
          target: {
            name: "dataAdmissaoExam",
            value: dateString
          }
        })}
        placeholder="dd/mm/aaaa"
        className={errors.dataAdmissaoExam ? 'is-invalid' : ''}
      />
      {errors.dataAdmissaoExam && (
        <div className="invalid-feedback">
          Data do exame é obrigatória
        </div>
      )}
    </div>
    <div className="col-md-6 col-lg-3">
      <label className="mb-2">Status de Aptidão Médica</label>
      <div className="d-flex flex-wrap gap-3">
        <div className="d-flex align-items-center gap-1">
          <RadioButton
            inputId="statu1"
            name="statusAptidao"
            value="Apto"
            onChange={(e) => setStatusAptidao(e.value)}
            checked={statusAptidao === "Apto"}
          />
          <label htmlFor="statu1">Apto</label>
        </div>
        <div className="d-flex align-items-center gap-1">
          <RadioButton
            inputId="statu2"
            name="statusAptidao"
            value="Não Apto"
            onChange={(e) => setStatusAptidao(e.value)}
            checked={statusAptidao === "Não Apto"}
          />
          <label htmlFor="statu2">Não Apto</label>
        </div>
      </div>
    </div>
    <div className="col-sm-12 col-md-6">
      <label htmlFor="foto" className="form-label">
        Exame <span className="text-danger">*</span>
      </label>
      <div className={errors.exame ? 'is-invalid' : ''}>
      <FileUpload
          ref={fileUploadRef}
        name="foto"
        chooseLabel="Escolher"
        uploadLabel="Enviar"
        cancelLabel="Cancelar"
        customUpload
        auto={false}
        uploadHandler={null}
        multiple={false}
        onSelect={HandleExameChange}
      />
      </div>
      {errors.exame && (
        <div className="invalid-feedback">
          Upload do exame médico é obrigatório
        </div>
      )}
    </div>
  </div>
);
};

ExameMedico.propTypes = {
  dados: PropTypes.shape({
    nomeMedico: PropTypes.string.isRequired,
    crm: PropTypes.string.isRequired
  }).isRequired,
  HandleChange: PropTypes.func.isRequired,
  setStatusAptidao: PropTypes.func.isRequired,
  HandleExameChange: PropTypes.func.isRequired,
  statusAptidao: PropTypes.string.isRequired,
  errors: PropTypes.shape({
    nomeMedico: PropTypes.bool,
    crm: PropTypes.bool,
    dataAdmissaoExam: PropTypes.bool,
    exame: PropTypes.bool
  }),
  exameFile: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.instanceOf(File)
  ])
};

ExameMedico.defaultProps = {
  errors: {},
  exameFile: null
};

export default ExameMedico;
